import React, { useState } from 'react';

import { app } from '../../sp-firebase/firebase';
import { createUserAccount } from '../../sp-firebase/userFB';

import { createUserWithEmailAndPassword, getAuth } from 'firebase/auth';
import Popup from '../popup/popup';
import { ComponentProps } from './LoginPage';

// interface Position {
//   id: number;
//   description: string;
// }

// interface RegisterAccountProps {
//   setActiveComponent: (key: string) => void;
//   setShowRegisterForm: React.Dispatch<React.SetStateAction<boolean>>;
//   setApprovalPending: React.Dispatch<React.SetStateAction<boolean>>;
// }

const RegisterAccount: React.FC<ComponentProps> = ({ setActiveComponent }) => {
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');

  const [companyId, setCompanyId] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [role, setRole] = useState('');
  const [email, setEmail] = useState('');
  const [phonePrefix, setPhonePrefix] = useState('');
  const [phone, setPhone] = useState('');
  const [checkTOS, setCheckTOS] = useState(false);

  /*const createAccount = async (event: any) => {
    event.preventDefault();
    const success = await register(email, password, email);
    if (success) {
      return <Navigate replace to="/dashboard" />;
    } else {

    }
  };*/

  const register = async (event: any) => {
    try {
      event.preventDefault();
      const auth = getAuth(app);

      await createUserWithEmailAndPassword(auth, email, 'Aa123456').then((userCredential) => {
        // Signed in
        const user = userCredential.user;

        const accountData = {
          companyName: companyName,
          companyId: companyId,
          email: email,
          phone: phone,
          firstName: firstName,
          lastName: lastName,
          address1: address1,
          address2: address2,
          confirmed: false,
        };
        createUserAccount(accountData, user.uid);
        sessionStorage.setItem('uid', user.uid);
        setActiveComponent('Pending');
      });
      // User is created
    } catch (error) {
      // Handle Errors here.
      console.error(error);
    }
  };

  return (
    <div className="p-5 leading-4">
      <div className="h-[90vh] w-full d-flex justify-content-center align-items-center">
        <div className="pt-4">
          <p className="text-xl text-red">Sign Up</p>
          <h4 className="title text-lg leading-5">
            Already a member?{' '}
            <a
              className="text-purple"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setActiveComponent('Login');
              }}
            >
              Log in
            </a>
          </h4>
          <form onSubmit={register}>
            <div className="py-5">
              <div className="flex">
                <div className="mb-3">
                  <label className="text-xs">First Name</label>
                  <input
                    className="text-sm border-1 mt-1 me-3 p-2 opacity-40 h-[2.75vh] w-[7.1vw] rounded"
                    type="text"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="text-xs">Last Name</label>
                  <input
                    className="text-sm border-1 mt-1 p-2 opacity-40 h-[2.75vh] w-[7.1vw] rounded"
                    type="text"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="mb-3">
                <label className="text-xs">Role</label>
                <input
                  className="text-sm border-1 mt-1 p-2 opacity-40 h-[2.75vh] w-[15vw] rounded"
                  type="text"
                  placeholder="Enter your role"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="text-xs">Phone</label>
                <div className="flex">
                  <input
                    className="text-sm border-1 mt-1 me-3 p-2 opacity-40 h-[2.75vh] w-[3.25vw] rounded"
                    type="text"
                    placeholder="prefix"
                    value={phonePrefix}
                    onChange={(e) => setPhonePrefix(e.target.value)}
                    required
                  />
                  <input
                    className="text-sm border-1 mt-1 p-2 opacity-40 h-[2.75vh] w-[10.9vw] rounded"
                    type="text"
                    placeholder="Phone number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="text-xs">Email</label>
                <input
                  className="text-sm border-1 mt-1 p-2 opacity-40 h-[2.75vh] w-[15vw] rounded"
                  type="email"
                  placeholder="Enter email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="text-xs">Company Name</label>
                <input
                  className="text-sm border-1 mt-1 p-2 opacity-40 h-[2.75vh] w-[15vw] rounded"
                  type="text"
                  placeholder="Enter company Name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="text-xs">Company ID (BN Number)</label>
                <input
                  className="text-sm border-1 mt-1 p-2 opacity-40 h-[2.75vh] w-[15vw] rounded"
                  type="text"
                  placeholder="Enter company ID"
                  value={companyId}
                  onChange={(e) => setCompanyId(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="text-xs">Registered office address</label>
                <input
                  className="text-sm border-1 mt-1 mb-3 p-2 opacity-40 h-[2.75vh] w-[15vw] rounded"
                  type="text"
                  placeholder="Street"
                  value={address1}
                  onChange={(e) => setAddress1(e.target.value)}
                  required
                />
                <input
                  className="text-sm border-1 mt-1 mb-3 p-2 opacity-40 h-[2.75vh] w-[15vw] rounded"
                  type="text"
                  placeholder="City"
                  value={address2}
                  onChange={(e) => setAddress2(e.target.value)}
                  required
                />
                <div className="flex">
                  <input
                    className="text-sm border-1 mt-1 me-3 p-2 opacity-40 h-[2.75vh] w-[10.9vw] rounded"
                    type="text"
                    placeholder="Country"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                  <input
                    className="text-sm border-1 mt-1 p-2 opacity-40 h-[2.75vh] w-[3.25vw] rounded"
                    type="text"
                    placeholder="Code"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="mb-3 flex">
                <input
                  type="checkbox"
                  checked={checkTOS}
                  onChange={() => setCheckTOS(!checkTOS)}
                  className="form-checkbox opacity-40 h-4 w-4 mr-2"
                  required
                />
                <p className="text-sm text-gray-700 opacity-80">
                  I have read and agree to the{' '}
                  <Popup hyperlink="terms of service" url="https://www.spotlock.co/terms" /> and{' '}
                  <Popup hyperlink="privacy policy" url="https://www.spotlock.co/privacy" />.
                </p>
              </div>

              <div className="mt-12">
                <button
                  type="button"
                  className="bg-gray-700 opacity-50 border rounded text-white text-sm h-[4vh] w-[6vw]"
                  onClick={() => setActiveComponent('Login')}
                >
                  Cancel
                </button>
                <button type="submit" className="bg-purple border rounded text-white text-sm ms-4 h-[4vh] w-[6vw]">
                  Sign Up
                </button>
              </div>
              <p className="text-red pt-4">* All fields are required.</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterAccount;
